<template>
  <div class="flex flex-col gap-1">
    <label v-if="label" class="text-body-small text-left font-medium">{{ label }}</label>

    <div>
      <InputText
        ref="input"
        v-model="number"
        autocomplete="one-time-code"
        :message="t('set_country_prefix')"
        :name="name"
        :placeholder="t('phone')"
        @update:model-value="updatePhone"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n();

  const emit = defineEmits(["update:modelValue"]);

  const {
    label = undefined,
    name = undefined,
    setPrefix = undefined,
    values = undefined,
  } = defineProps<{
    label?: string;
    name?: string;
    setPrefix?: string;
    values?: any;
  }>();

  onMounted(() => {
    if (values) {
      number.value = values.phone_number;
    }
  });

  watch(
    () => setPrefix,
    (val, oldVal) => {
      if (val && prefixes.value) {
        const newPrefix = prefixes.value.find((prefix) => prefix.iso === val)?.value;
        const oldPrefix = prefixes.value.find((prefix) => prefix.iso === oldVal)?.value;
        if (newPrefix === oldPrefix) return;
        number.value = (input.value?.inputValue ?? "").replace(oldPrefix ?? "", newPrefix ?? "");
        input.value?.setValue(number.value);
      }
    }
  );

  const { prefixes } = storeToRefs(useCountriesStore());

  const number = ref("");
  const input = useTemplateRef("input");

  const updatePhone = () => {
    emit("update:modelValue", { phone_number: number.value });
  };
</script>
